import { DEFAULT_LANDING_STATIC, extractMainDomain } from "./pickLandingDomain";

/**
 * 滑块通过后跳转落地页
 * 仅做两件事：download 域名前加 t{时间戳} 子域；追加 agent、f（子域已含 t，不再带 ?t=）
 */
export function getPermanentSiteUrl() {
  const { origin, pathname } = window.location;
  const path = pathname && pathname !== "/" ? pathname : "/";
  return `${origin}${path}`;
}

export function encodePermanentSiteParam(url) {
  return btoa(unescape(encodeURIComponent(String(url))));
}

function isIpOrLocalhost(host) {
  return (
    host === "localhost" ||
    /^(\d{1,3}\.){3}\d{1,3}$/.test(host)
  );
}

/** 从当前页 href 读取 agent / agentId / agent_id */
export function getAgentFromCurrentHref() {
  const href = decodeURIComponent(window.location.href);
  const keys = ["agent", "agentId", "agent_id"];
  const segments = [];

  const hashIdx = href.indexOf("#");
  const searchIdx = href.indexOf("?");

  if (searchIdx >= 0) {
    const end = hashIdx >= 0 && hashIdx > searchIdx ? hashIdx : href.length;
    segments.push(href.slice(searchIdx + 1, end));
  }
  if (hashIdx >= 0) {
    const hashPart = href.slice(hashIdx + 1);
    const qInHash = hashPart.indexOf("?");
    if (qInHash >= 0) segments.push(hashPart.slice(qInHash + 1));
  }

  for (const seg of segments) {
    const params = new URLSearchParams(seg);
    for (const key of keys) {
      const v = params.get(key);
      if (v != null && String(v).trim() !== "") return String(v).trim();
    }
  }
  return null;
}

function parseDownloadUrl(landingRaw) {
  const trimmed = String(landingRaw || "").trim();
  if (!trimmed) return new URL(DEFAULT_LANDING_STATIC);
  try {
    return new URL(
      /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`
    );
  } catch {
    return new URL(DEFAULT_LANDING_STATIC);
  }
}

function applyAntiBotParams(params, antiBot) {
  if (!antiBot) return;
  if (antiBot.hitModules?.length) {
    params.set("_m", antiBot.hitModules.join(","));
  }
  if (antiBot.totalScore != null) {
    params.set("_r", String(antiBot.totalScore));
  }
}

/** 在 download 原 URL 上追加 agent、f、_m、_r，不改 hash 路径 */
function appendParamsToDownloadUrl(url, { agent, permanentSite, antiBot }) {
  if (url.hash && url.hash.length > 1) {
    const hashContent = url.hash.slice(1);
    const qIdx = hashContent.indexOf("?");
    const hashPath = qIdx >= 0 ? hashContent.slice(0, qIdx) : hashContent;
    const params = new URLSearchParams(
      qIdx >= 0 ? hashContent.slice(qIdx + 1) : ""
    );
    params.delete("t");
    params.delete("T");
    if (agent && !params.has("agent")) params.set("agent", String(agent));
    if (permanentSite) params.set("f", encodePermanentSiteParam(permanentSite));
    applyAntiBotParams(params, antiBot);
    const path = hashPath.startsWith("/") ? hashPath : `/${hashPath}`;
    const qs = params.toString();
    return `${url.origin}${url.pathname}#${path}${qs ? `?${qs}` : ""}`;
  }

  const params = new URLSearchParams(url.search);
  params.delete("t");
  params.delete("T");
  if (agent && !params.has("agent")) params.set("agent", String(agent));
  if (permanentSite) params.set("f", encodePermanentSiteParam(permanentSite));
  applyAntiBotParams(params, antiBot);
  const qs = params.toString();
  return `${url.origin}${url.pathname}${qs ? `?${qs}` : ""}`;
}

export function buildLandingRedirectUrl(agentId, options = {}) {
  const ts = Math.floor(Date.now() / 1000);
  const permanentSite = options.permanentSite ?? getPermanentSiteUrl();
  const landingRaw = options.landingDomain || DEFAULT_LANDING_STATIC;
  const url = parseDownloadUrl(landingRaw);
  const agent =
    agentId ||
    getAgentFromCurrentHref() ||
    null;

  let redirectUrl;

  const antiBot = options.antiBot || null;
  const extraQuery = options.extraQuery || "";

  if (isIpOrLocalhost(url.hostname)) {
    redirectUrl = appendParamsToDownloadUrl(url, {
      agent,
      permanentSite,
      antiBot,
    });
  } else {
    const mainHost = extractMainDomain(url.hostname);
    url.hostname = `t${ts}.${mainHost}`;
    redirectUrl = appendParamsToDownloadUrl(url, {
      agent,
      permanentSite,
      antiBot,
    });
  }

  if (extraQuery) {
    redirectUrl += (redirectUrl.includes("?") ? "&" : "?") + extraQuery;
  }

  return redirectUrl;
}

export { extractMainDomain };
